import { render, staticRenderFns } from "./Bar-Chart.vue?vue&type=template&id=72d29d3e&scoped=true"
import script from "./Bar-Chart.vue?vue&type=script&lang=js"
export * from "./Bar-Chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d29d3e",
  null
  
)

export default component.exports